const state = {
    qrCanvasDesign: {
        qrCardWidth: 300,
        qrImgWidth: 120,
        textAlignment: "left",
        qrImgAlignment: "left",
        direction: "row",
        qrCardBorderLine: 1,
        qrCardNumber: 1,
    },
    qrCodeDesign: {
        qrTitleFontSize: 12,
        qrTitleLineHeight: 12,
        exampleText: "LOREM IPSUM",
    },
    qrDescDesign: {
        qrDescFontSize: 12,
        qrDescLineHeight: 12,
        qrDescNumber: 1,
        exampleText: "Lorem ipsum",
    },
};

const mutations = {
    SET_QR_CANVAS_DESIGN: (state, info) => {
        state.qrCanvasDesign = info;
    },
    SET_QR_CODE_DESIGN: (state, info) => {
        state.qrCodeDesign = info;
    },
    SET_QR_DESC_DESIGN: (state, info) => {
        state.qrDescDesign = info;
    },
};

const actions = {
    setQrCanvasDesign({ commit }, info) {
        console.log("qrCanvasDesign store", info);
        commit("SET_QR_CANVAS_DESIGN", info);
    },
    setQrCodeDesign({ commit }, info) {
        console.log("qrCodeDesign store", info);
        commit("SET_QR_CODE_DESIGN", info);
    },
    setQrDescDesign({ commit }, info) {
        console.log("qrDescDesign store", info);
        commit("SET_QR_DESC_DESIGN", info);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/barcode_conf.js